<article class="lum-page lum-page__card lum-c-receiving">
  <header class="lum-page-header">
    <h3 class="lum-page-header__heading">Receiving</h3>
    <div class="lum-page-header__actions">
      <button
        type="button"
        class="lum-button lum-button--primary"
        (click)="handleCreateClick($event)"
      >
        <i class="fas fa-plus" role="presentation"></i>
        Create Receiving Report
      </button>
    </div>
  </header>

  <cnc-receiving-reports
    class="lum-page-content"
    [add$]="addReceiving$"
  ></cnc-receiving-reports>
</article>
